var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSectionCollapseArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6708 6L9.33081 6C6.01081 6 4.66081 8.35 6.31081 11.22L7.05081 12.5C7.23081 12.81 7.56081 13 7.92081 13L16.0808 13C16.4408 13 16.7708 12.81 16.9508 12.5L17.6908 11.22C19.3408 8.35 17.9908 6 14.6708 6Z",
    fill: "#50429B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2085 14L8.77848 14C8.38848 14 8.14848 14.42 8.34848 14.75L8.98848 15.85C10.6385 18.72 13.3585 18.72 15.0085 15.85L15.6485 14.75C15.8385 14.42 15.5985 14 15.2085 14Z",
    fill: "#50429B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionCollapseArrowDown);
export default __webpack_public_path__ + "static/media/section-collapse-arrow-down.c7283213483c517aa7a4c9164614a491.svg";
export { ForwardRef as ReactComponent };